import React, { useState, useEffect } from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { getCompanies } from 'api';

const CompanyFilterBtn = ({value, onChange}) => {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const loadCompanies = async () => {
      try {
        const companiesData = await getCompanies();
        setCompanies(
          Array.isArray(companiesData) ? companiesData : []
        );
      } catch (error) {
        console.error('Error loading companies in CompanyFilterBtn:', error);
        setCompanies([]);
      }
    };

    loadCompanies();
  }, []);

  return (
    <FormControl  
      size="small" sx={{ 
      minWidth: { xs: "50%", sm: 200 },
      width: { xs: "70%", sm: "auto" }
    }}>
        <InputLabel>Filter by Company</InputLabel>
        <Select
          value={value??''} //this makes the parent control value
          label="Filter by Company"
          onChange={(e)=> onChange?.(e.target.value)} //notify parent
        >
            <MenuItem value="">
              All companies
            </MenuItem>
           {companies.map((company) => (
            <MenuItem key={company.Id} value={company.Id}>
                {company.Name}
            </MenuItem>
            ))}
        </Select>
    </FormControl>
  );
};

export default CompanyFilterBtn;
